import styled from 'styled-components'

export const GraphAreaWidgetStyled = styled.div`
`
